import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

//import { FeedbackComponent } from '../shared/components/feedback/feedback.component';
import { AuthService } from '../shared/services/auth.service';
import { FooterComponent } from './footer/footer.component';
import { FreeTrialBannerComponent } from './free-trial-banner/free-trial-banner.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';

import { IUserDTO } from '../shared/api/models/v1/user';
import { SubscriptionTierEnum } from '../shared/enums/subscription-tier';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TopbarComponent,
    SidebarComponent,
    FooterComponent,
    FreeTrialBannerComponent
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  public authUser?: IUserDTO | null;
  public isFreeTrial: boolean = false;
  public sidebarSize: string | null = null;

  private subscriptions: Subscription[] = [];
  private hasLoadedTawk = false;

  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    document.documentElement.setAttribute('data-layout', 'vertical');
    document.documentElement.setAttribute('data-topbar', 'light');
    document.documentElement.setAttribute('data-sidebar', 'dark');
    document.documentElement.setAttribute('data-layout-style', 'default');
    document.documentElement.setAttribute('data-layout-mode', 'light');
    document.documentElement.setAttribute('data-layout-width', 'fluid');
    document.documentElement.setAttribute('data-layout-position', 'fixed');
    document.documentElement.setAttribute('data-sidebar-image', 'none');
    document.documentElement.setAttribute('data-preloader', 'disable');

    window.addEventListener('resize', function () {
      if (document.documentElement.clientWidth <= 767) {
        document.documentElement.setAttribute('data-sidebar-size', '');
      }
      else if (document.documentElement.clientWidth <= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      else if (document.documentElement.clientWidth >= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
    });

    this.authUser = this.authService.getUser();
    this.checkIsTrial();
    if (this.authUser) {
      this.loadTawk();
    }
    this.subscriptions.push(this.authService.user$.subscribe((user: IUserDTO | null) => {
      this.authUser = user;
      this.checkIsTrial();
      if (this.authUser) {
        this.loadTawk();
      }
    }));

    this.checkSidebarState();
    setInterval(() => {
      this.checkSidebarState();
    }, 100);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  private checkSidebarState() {
    this.sidebarSize = document.documentElement.getAttribute('data-sidebar-size');
  }
  
  private loadTawk() {
    if (this.hasLoadedTawk) return;
    this.hasLoadedTawk = true;
    if(!environment.production) return;

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    var Tawk_API=Tawk_API||{};
Tawk_API.visitor = {
name : '${this.authUser?.name}',
email : '${this.authUser?.email}'
};

console.log('Tawk_API.visitor', Tawk_API.visitor);

var Tawk_LoadStart=new Date();
  (function () {
    var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/65e3375a9131ed19d973eed8/1hnvp0et6';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  })();
`;

    this.renderer.appendChild(document.body, script);
  }

  private checkIsTrial() {
    this.isFreeTrial = !this.authUser ? false : this.authService.getActiveSubscriptionId() == SubscriptionTierEnum.Free;
  }

  public onShowFeedback(): void {
    // Previously opened a Bootstrap modal (FeedbackComponent via NgbModal).
    // We no longer depend on ng-bootstrap; show a lightweight toast instead.
    this.toastr.info('Feedback modal coming soon.', '', {
      positionClass: 'toast-bottom-right'
    });
  }

  /**
   * On mobile toggle button clicked
   */
  public onToggleMobileMenu() {
    const currentSIdebarSize = document.documentElement.getAttribute("data-sidebar-size");
    if (document.documentElement.clientWidth >= 767) {
      if (currentSIdebarSize == null) {
        (document.documentElement.getAttribute('data-sidebar-size') == null || document.documentElement.getAttribute('data-sidebar-size') == "lg") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg')
      } else if (currentSIdebarSize == "md") {
        (document.documentElement.getAttribute('data-sidebar-size') == "md") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'md')
      } else {
        (document.documentElement.getAttribute('data-sidebar-size') == "sm") ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm')
      }
    }

    if (document.documentElement.clientWidth <= 767) {
      document.body.classList.toggle('vertical-sidebar-enable');
    }
  }

  /**
   * on settings button clicked from topbar
   */
  public onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    const rightBar = document.getElementById('theme-settings-offcanvas');
    if (rightBar != null) {
      rightBar.classList.toggle('show');
      rightBar.setAttribute('style', "visibility: visible;");

    }
  }
}